module.exports = __webpack_public_path__ + "img/TC11EC.9ad9e38a.svg";